<template>
    <div>
        <v-client-table :data="periods" :columns="columns" :options="options">
            <div slot="price" slot-scope="props" v-html="props.row.price_html">
            </div>
            <div slot="tour_name" slot-scope="props">
                <a :href="props.row.tour_permalink">{{ props.row.tour_name }}</a>
            </div>
        </v-client-table>
    </div>

</template>

<script>
    import Vue from 'vue';
    import {ClientTable} from 'vue-tables-2';
    import {compareAsc, compareDesc} from 'date-fns'

    Vue.use(ClientTable);

    export default {
        props: [
            'periods'
        ],
        data() {
            return {
                columns: [
                    'date',
                    'nights',
                    'tour_name',
                    'price',
                    'badge_title'
                ],
                options: {
                    // see the options API
                    sortIcon:{
                        base:'far ',
                        is:'fa-sort',
                        up: 'fa-sort-up',
                        down: 'fa-sort-down'
                    },
                    orderBy: {
                        ascending: true,
                        column: 'date'
                    },
                    pagination: {
                        edge: false,
                        dropdown: false,
                        chunk: 15
                    },
                    perPage: 15,
                    headings: {
                        tour_name: 'Tour',
                        thumbnail: '',
                        price: 'Price (from)',
                        badge_title: 'Status',
                        nights: 'Days'
                    },
                    sortable: [
                        'date',
                        'price',
                        'nights',
                        'status',
                        'tour_name'
                    ],
                    filterByColumn: false,
                    filterable: false,
                    customSorting: {
                        date(ascending) {
                            return (a, b) => ascending ? compareAsc(a.from, b.from) : compareDesc(a.from, b.from);
                        },
                        price(ascending) {
                            return (a, b) => {
                                return ascending ? a.price - b.price : b.price - a.price;
                            }
                        }
                    }
                }
            }
        },
    }
</script>

<style lang="scss">

    .VueTables {

        &__search, &__limit, &__count {
            display: none;
        }
        &__pagination {
            margin: 0;
            padding: 0;
            list-style: none;
        }
        &__sortable {
            cursor: pointer;
        }
        &__table {
            width: 100%;
            .far {
                color: white;
                padding-top: 5px;
            }
            thead {
                background-color: #6ea0ff;
                color: white;
            }
            th, td {
                text-align: center;
            }
        }
        // hide columns for tablet / mobile
        @media(max-width: 1000px) {
            th:nth-child(n+5), td:nth-child(n+5) {
                display: none;
            }
        }
        // hide columns for tablet / mobile
        @media(max-width: 320px) {
            th:nth-child(n+4), td:nth-child(n+4) {
                display: none;
            }
        }
    }

    .VuePagination {
        text-align: center;
        background-color: white;
        margin-top: 1em;
        &__pagination {
            margin: 0;
            padding: 0;
            list-style: none;
        }
        &__count {
            display: none;
        }
        &__pagination-item {
            display: inline-block;
            &.active {
                background-color: #f67b25;
                a {
                    color: white;
                }
            }
            a {
                padding: 8px;
                border: 1px solid #f67b25;
                line-height: 34px;
            }
        }
        // no arrows
        &__pagination-item-prev-chunk, &__pagination-item-prev-page,  &__pagination-item-next-chunk, &__pagination-item-next-page {
            display: none;
        }
    }

</style>
